import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Select, FormControl } from 'components';
import styles from './DropdownPreview.scss';

const Dropdown = ({
    options,
    defaultSelected,
    isDisabled,
    onChange,
    ...selectProps
}) => {
    
    const handleSelect = (selectedValue) => {
        const selected = options.find(option => option.value === selectedValue);
        onChange(selected);
    };

    return (
        <FormControl fullWidth>
            <Select
                fullWidth={false}
                variant='standard'
                afterChange={handleSelect}
                defaultValue={get(defaultSelected, 'value', '')}
                className={styles.selectRequirement}
                options={options}
                disabled={isDisabled}
                { ...selectProps }
            />
        </FormControl>
    );
};

Dropdown.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        display: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    })),
    defaultSelected: PropTypes.shape({
        display: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }),
    isDisabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

Dropdown.defaultProps = {
    defaultSelected: {
        value: '', display: ''
    }
};

export default Dropdown;
